import request from '@/utils/request'

export function ppnLogin(param) {
    return request({
        url: `/ocs-auth/sso/porsche/login${param}`,
        method: 'get'
    })
}

export function ppnGetToken(data) {
    return request({
        url: '/ocs-auth/auth/getTokenByCode',
        method: 'post',
		data: data
    })
}


export function menuSelectTree() {
    return request({
        url: '/ocs-auth/menu/select/tree',
        method: 'get'
    })
}

// 查询license信息
export function ocsLicenseGet(brandIdentify){
    return request({
        url: `/ocs-auth/ocs/license/get/${brandIdentify}`,
        method: 'get'
    })
}

// 超级管理员手动设置License
export function oscLicenseSet(brandIdentify,data){
    return request({
        url: `/ocs-auth/ocs/license/set/${brandIdentify}`,
        method: "post",
        data
    })
}

// License上传
export function oscLicenseUpload(brandIdentify,data){
    return request({
        url: `/ocs-auth/ocs/license/upload/${brandIdentify}`,
        method: "post",
        data
    })
}

// 删除license
export function oscLicenseDelete(brandIdentify){
    return request({
        url: `/ocs-auth/ocs/license/delete/${brandIdentify}`,
        method: "post"
    })
}

// 查询OCS+当前版本号
export function ocsGetVersion() {
    return request({
        url: '/ocs-auth/ocs/get/version',
        method: 'get',
    })
}

// 查询OCS+历史版本号
export function ocsGetVersionHistory() {
    return request({
        url: '/ocs-auth/ocs/get/version/history',
        method: 'get',
    })
}

// 新增OCS+版本号
export function ocsAddVersion(data) {
    return request({
        url: '/ocs-auth/ocs/add/version',
        method: 'post',
        data
    })
}